import { Suspense, lazy } from 'react'

import { CircularProgress } from 'ui/components'

const NextCloudContainer = lazy(() => import('./routes/NextCloudContainer/NextCloudContainer'))

export const BankNextCloudWrapper = () => (
  <Suspense fallback={<CircularProgress centered />}>
    <NextCloudContainer />
  </Suspense>
)
